import module from 'collapse-whitespace';
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var collapseWhitespace = module;
export default collapseWhitespace;